import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RemocaoComunicacaoComponent } from './modules/_pages/_remocao-comunicacao/remocao-comunicacao.component';

import { AjudaComponent } from './modules/_pages/_ajuda/ajuda.component';
import { BeneficiosComponent } from './modules/_pages/_beneficios/beneficios.component';
import { CadastroParceirosComponent } from './modules/_pages/_cadastro-parceiros/cadastro-parceiros.component';
import { DesafiosComponent } from './modules/_pages/_desafios/desafios.component';
import { EsqueciSenhaComponent } from './modules/_pages/_esqueci-senha/esqueci-senha.component';
import { ExperienciaDetalheComponent } from './modules/_pages/_experiencia-detalhe/experiencia-detalhe.component';
import { ExtratoComponent } from './modules/_pages/_extrato/extrato.component';
import { IndexComponent } from './modules/_pages/_index/index.component';
import { IndicacoesComponent } from './modules/_pages/_indicacoes/indicacoes.component';
import { LandingPageComponent } from './modules/_pages/_landing-page/landing-page.component';
import { LoginRedirectComponent } from './modules/_pages/_login-redirect/login-redirect.component';
import { LogoutComponent } from './modules/_pages/_logout/logout.component';
import { LoversPelaCausaComponent } from './modules/_pages/_lovers-pela-causa/lovers-pela-causa.component';
import { LpPromocionalComponent } from './modules/_pages/_lp-promocional/lp-promocional.component';
import { MeusDadosComponent } from './modules/_pages/_meusdados/meusdados.component';
import { MinhasExperienciasComponent } from './modules/_pages/_minhas-experiencias/minhas-experiencias.component';
import { MomentosEspeciaisComponent } from './modules/_pages/_momentos-especiais/momentos-especiais.component';
import { PalitoPremiadoComponent } from './modules/_pages/_palito-premiado/palito-premiado.component';
import { RedefinicaoSenhaComponent } from './modules/_pages/_redefinicao-senha/redefinicao-senha.component';
import { ValidaDadosComponent } from './modules/_pages/_valida_dados/validadados.component';
import { ValidarDadosComponent } from './modules/_pages/_validar-dados/validar-dados.component';
import { AuthGuard } from './modules/_shared/components/auth/authGuard';
import { NoAuthGuard } from './modules/_shared/components/auth/noAuthGuard';
import { NotificacoesComponent } from './modules/_shared/components/notificacoes/notificacoes.component';
import { SolicitacoesComponent } from './modules/_shared/components/solicitacoes/solicitacoes.component';
import { RedirectComponent } from './modules/_pages/_redirect/redirect.component';

const routes: Routes = [
  {
    path: 'cadastro',
    component: RedirectComponent,
  },
  { path: 'home', component: LandingPageComponent, canActivate: [NoAuthGuard] },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'home',
  },
  // { path: 'home', component: HomeComponent, canActivate: [NoAuthGuard] },
  { path: 'loginredirect', component: LoginRedirectComponent },
  {
    path: 'esquecisenha',
    component: EsqueciSenhaComponent,
    canActivate: [NoAuthGuard],
  },
  { path: 'resetarsenha', component: RedefinicaoSenhaComponent },
  { path: 'index', component: IndexComponent, canActivate: [AuthGuard] },
  { path: 'extrato', component: ExtratoComponent, canActivate: [AuthGuard] },
  {
    path: 'momento-especial/:nomeIdentificador',
    component: ExperienciaDetalheComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'minhas-experiencias',
    component: MinhasExperienciasComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'desafios',
    component: DesafiosComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'meusdados',
    component: MeusDadosComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'notificacoes',
    component: NotificacoesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'solicitacoes',
    component: SolicitacoesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'indicacoes',
    component: IndicacoesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'ajuda/:tipo',
    component: AjudaComponent,
  },
  {
    path: 'ajuda',
    pathMatch: 'full',
    redirectTo: '/ajuda/cacaulovers',
  },
  {
    path: 'missoes',
    component: DesafiosComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'cadastro_parceiros',
    component: CadastroParceirosComponent,
  },
  {
    path: 'remocao',
    component: RemocaoComunicacaoComponent,
    canActivate: [NoAuthGuard],
  },
  {
    path: 'promocao',
    // component: LpPromocionalComponent,
    redirectTo: 'index',
  },
  // {
  //   path: 'palito-premiado',
  //   component: PalitoPremiadoComponent,
  // },
  {
    path: 'beneficios',
    component: BeneficiosComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'programa',
    component: LandingPageComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'momentos-especiais',
    component: MomentosEspeciaisComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'valida-dados',
    component: ValidaDadosComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'validar-dados',
    component: ValidarDadosComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'pela-causa',
    component: LoversPelaCausaComponent,
  },
  {
    path: 'lovers-pela-causa',
    component: LoversPelaCausaComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'logout',
    component: LogoutComponent,
    canActivate: [AuthGuard],
  },

  // otherwise redirect to home
  { path: '**', redirectTo: 'home' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
